import { Box } from '@mui/material';
import styled from '@mui/system/styled';

export const SearchListCnt = styled('ul')({
  maxHeight: '300px',
  overflow: 'auto',
  '& li': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '5px 24px',
    gap: '16px',
    ':hover': {
      cursor: 'pointer',
      background: '#EBEAFF',
    },
    '& .content': {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    },
    '& .textCnt': {
      display: 'flex',
      alignItems: 'flex-start',
      flexDirection: 'column',
      '& .title': {
        fontSize: '14px',
        fontWeight: 600,
        margin: 0,
      },
      '& .breadCrumbText': {
        fontSize: '12px',
        fontWeight: 500,
        color: '#616161',
      },
      '& .breadCrumbCnt': {
        display: 'flex',
        alignItems: 'center',
      },
    },
  },
});

export const FolderItem = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  padding: '12px 16px',
  borderRadius: '6px',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: 'rgba(235, 234, 255, 0.5)',
  },
  '& .title': {
    fontWeight: 500,
    fontSize: 14,
    color: '#212121',
  },
}));

export const TemplateItem = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  padding: '12px 16px',
  cursor: 'pointer',
  borderRadius: '6px',
  '& .title': {
    fontWeight: 500,
    fontSize: 14,
    color: '#212121',
  },
  '&:hover': {
    backgroundColor: 'rgba(235, 234, 255, 0.5)',
  },
  '&.selected': {
    backgroundColor: 'rgba(235, 234, 255, 1)',
    outline: '1px solid rgba(104, 104, 254, 1)',
  },
}));

export const Content = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  flex: 1,
}));
